import { render, staticRenderFns } from "./ImageGalleryUploadDialog.vue?vue&type=template&id=0a6b7f05&scoped=true"
import script from "./ImageGalleryUploadDialog.vue?vue&type=script&lang=ts"
export * from "./ImageGalleryUploadDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImageGalleryUploadDialog.vue?vue&type=style&index=0&id=0a6b7f05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b7f05",
  null
  
)

export default component.exports